import React from 'react'
import { object, element } from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { SETTINGS } from '../../constants/routes'

const ProtectedRoute = ({ component: Component, ...remainingProps }) => (
  <Route
    {...remainingProps}
    render={props => {
      const hasContext = !!props.location.key && !props.location.firstPage

      return hasContext ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: SETTINGS }} />
      )
    }}
  />
)

ProtectedRoute.propTypes = {
  component: element,
  location: object
}

export default ProtectedRoute
